import { FormControl, Validators } from '@angular/forms';
import { UliActivityType } from '../../../../../common/constants';
import { ActiveCompartmentsModel } from '../uli/models/uli-creation.model';
import { AllocationUliRuleSlot } from './allocation-details/allocation-uli-rule.model';

export class UliCreateSelectionModel {
  type = UliActivityType.Outbound;
  compartment: ActiveCompartmentsModel;

  constructor(params?: UliCreateSelectionModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class UliCreateSelectionForm {
  constructor(
    model: UliCreateSelectionModel,
    public type: FormControl<UliActivityType> = new FormControl(model.type, [Validators.required]),
    public compartment: FormControl<ActiveCompartmentsModel> = new FormControl(model.compartment, [
      Validators.required,
    ]),
  ) {}
}

export class UliCreateSelectionRuleModel {
  ruleId: number = null;
  slot: AllocationUliRuleSlot = null;

  constructor(params?: UliCreateSelectionRuleModel) {
    if (params) {
      this.ruleId = params.ruleId;
      this.slot = params.slot;
    }
  }
}

export class UliCreateSelectionRuleForm {
  constructor(
    model: UliCreateSelectionRuleModel,
    public ruleId: FormControl<number> = new FormControl(model.ruleId),
    public slot: FormControl<AllocationUliRuleSlot> = new FormControl(model.slot),
  ) {}
}
